import { authenticated } from '../../helpers/auth-header';
import insighttAPI from '../clients/insightt-api-client';
import { statsEndpoints } from '../endpoints';

const getActivityLevel = (branchId, roleId, startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(
    statsEndpoints.getActivityLevelAPI(branchId, roleId, startDate, endDate, timezoneOffset),
  );

const getInfractions = (branchId, roleId, startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(
    statsEndpoints.getInfractionsAPI(branchId, roleId, startDate, endDate, timezoneOffset),
  );

const getTotalMissedRepossessions = (branchId, startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(
    statsEndpoints.getTotalMissedRepossessionsAPI(branchId, startDate, endDate, timezoneOffset),
  );

const getMissedRepossessions = (branchId, startDate, endDate, timezoneOffset, currentPage, pageSize, search) =>
  authenticated(insighttAPI).get(
    statsEndpoints.getMissedRepossessionsAPI(
      branchId,
      startDate,
      endDate,
      timezoneOffset,
      currentPage,
      pageSize,
      search,
    ),
  );

const getTotalSpottedVehicles = (branchId, startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(
    statsEndpoints.getTotalSpottedVehiclesAPI(branchId, startDate, endDate, timezoneOffset),
  );

const getSpottedVehicles = (branchId, startDate, endDate, timezoneOffset, currentPage, pageSize, search) =>
  authenticated(insighttAPI).get(
    statsEndpoints.getSpottedVehiclesAPI(
      branchId,
      startDate,
      endDate,
      timezoneOffset,
      currentPage,
      pageSize,
      search,
    ),
  );

const getTotalRepossessions = (branchId, startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(
    statsEndpoints.getTotalRepossessionsAPI(branchId, startDate, endDate, timezoneOffset),
  );

const getRepossessions = (branchId, startDate, endDate, timezoneOffset, currentPage, pageSize, search) =>
  authenticated(insighttAPI).get(
    statsEndpoints.getRepossessionsAPI(
      branchId,
      startDate,
      endDate,
      timezoneOffset,
      currentPage,
      pageSize,
      search,
    ),
  );

const getHoursWorked = (branchId, startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(statsEndpoints.getHoursWorkedAPI(branchId, startDate, endDate, timezoneOffset));

const getTotalCommissions = (branchId, startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(
    statsEndpoints.getTotalCommissionsAPI(branchId, startDate, endDate, timezoneOffset),
  );

const getCommissions = (branchId, type, startDate, endDate, timezoneOffset, currentPage, pageSize, search) =>
  authenticated(insighttAPI).get(
    statsEndpoints.getCommissionsAPI(
      branchId,
      type,
      startDate,
      endDate,
      timezoneOffset,
      currentPage,
      pageSize,
      search,
    ),
  );

const getMyActivityLevel = (startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(statsEndpoints.getMyActivityLevelAPI(startDate, endDate, timezoneOffset));

const getMyMissedOpportunities = (startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(statsEndpoints.getMyMissedOpportunitiesAPI(startDate, endDate, timezoneOffset));

const getMyInfractions = (startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(statsEndpoints.getMyInfractionsAPI(startDate, endDate, timezoneOffset));

const getMySpottedVehicles = (startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(statsEndpoints.getMySpottedVehiclesAPI(startDate, endDate, timezoneOffset));

const getMyRepossessions = (startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(statsEndpoints.getMyRepossessionsAPI(startDate, endDate, timezoneOffset));

const getMyHoursWorked = (startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(statsEndpoints.getMyHoursWorkedAPI(startDate, endDate, timezoneOffset));

const getMyCommissions = (startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(statsEndpoints.getMyCommissionsAPI(startDate, endDate, timezoneOffset));

const getUserInfractions = (userId, startDate, endDate, timezoneOffset, currentPage, pageSize, search) =>
  authenticated(insighttAPI).get(
    statsEndpoints.getUserInfractionsAPI(
      userId,
      startDate,
      endDate,
      timezoneOffset,
      currentPage,
      pageSize,
      search,
    ),
  );

const getDayShifts = (userid, date, timezoneOffset) =>
  authenticated(insighttAPI).get(statsEndpoints.getDayShiftsAPI(userid, date, timezoneOffset));

const getDayExtraneousTimes = (userId, date, timezoneOffset) =>
  authenticated(insighttAPI).get(statsEndpoints.getDayExtraneousTimesAPI(userId, date, timezoneOffset));

export const statsService = {
  getActivityLevel,
  getInfractions,
  getTotalMissedRepossessions,
  getMissedRepossessions,
  getTotalSpottedVehicles,
  getSpottedVehicles,
  getTotalRepossessions,
  getRepossessions,
  getHoursWorked,
  getTotalCommissions,
  getCommissions,
  getMyActivityLevel,
  getMyInfractions,
  getMySpottedVehicles,
  getMyRepossessions,
  getMyHoursWorked,
  getMyCommissions,
  getUserInfractions,
  getDayShifts,
  getDayExtraneousTimes,
  getMyMissedOpportunities,
};
